import { render, staticRenderFns } from "./stuApply.vue?vue&type=template&id=ab97dccc&scoped=true&"
import script from "./stuApply.vue?vue&type=script&lang=js&"
export * from "./stuApply.vue?vue&type=script&lang=js&"
import style0 from "./stuApply.vue?vue&type=style&index=0&id=ab97dccc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab97dccc",
  null
  
)

export default component.exports